import auth from './auth'
import core from './core'
import system from './system'
import workspace from './workspace'
import project from './project'
import onboarding from './onboarding'

export default {
  auth,
  core,
  system,
  workspace,
  project,
  onboarding
}